import React, { useId, useState } from "react";

export default function ChatInputComponent({
                                               onSend,
                                               onTyping,
                                               onAttach,
                                               disabled = false,
                                               disabledReason = "",
                                           }) {
    const [texto, setTexto] = useState("");
    const fileId = useId();

    const placeholder = disabled
        ? disabledReason || "No puedes escribir en esta sala…"
        : "Escribe un mensaje…";

    const enviar = () => {
        if (disabled) return;
        const t = (texto || "").trim();
        if (!t) return;

        onSend?.(t);
        setTexto("");
        onTyping?.(false);
    };

    const handleKeyDown = (e) => {
        if (disabled) return;
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            enviar();
        }
    };

    const handleAttach = (e) => {
        const file = e.target.files?.[0];
        if (!file || disabled) return;

        onAttach?.(file);
        e.target.value = "";
    };

    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
                enviar();
            }}
            className="flex items-end gap-2 w-full"
            aria-label="Enviar mensaje"
        >
            <div className="flex-1">
                <label htmlFor="chat-text" className="sr-only">
                    Mensaje
                </label>

                <textarea
                    id="chat-text"
                    rows={1}
                    className="
            w-full resize-none rounded-2xl border border-gray-300 bg-white
            px-4 py-3 text-base md:text-lg
            placeholder-gray-400
            focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
            disabled:bg-gray-100 disabled:text-gray-500
          "
                    placeholder={placeholder}
                    value={texto}
                    onChange={(e) => {
                        const v = e.target.value;
                        setTexto(v);
                        if (!disabled) onTyping?.(v.length > 0);
                    }}
                    onBlur={() => onTyping?.(false)}
                    onKeyDown={handleKeyDown}
                    disabled={disabled}
                />

                {disabled && disabledReason && (
                    <p className="mt-1 text-xs text-gray-500" role="note">
                        {disabledReason}
                    </p>
                )}
            </div>

            <button
                type="submit"
                disabled={disabled || !texto.trim()}
                aria-label="Enviar mensaje"
                className="
          inline-flex items-center justify-center
          h-[46px] px-5 rounded-full
          bg-blue-600 text-white font-medium
          hover:bg-blue-700
          focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
          disabled:opacity-60 disabled:cursor-not-allowed
        "
            >
                Enviar
            </button>
        </form>
    );
}
